"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyTemplateFieldValue = emptyTemplateFieldValue;
exports.normalizeTemplateFieldValue = normalizeTemplateFieldValue;
exports.findStickedUploadBox = findStickedUploadBox;
exports.isUploadBoxHidden = isUploadBoxHidden;
exports.createInitialTemplateFormValues = createInitialTemplateFormValues;
exports.validateTemplateForm = validateTemplateForm;
exports.buildTemplateSubmitPayload = buildTemplateSubmitPayload;
exports.extractTemplateFormTitle = extractTemplateFormTitle;
function emptyTemplateFieldValue() {
    return {
        text: '',
        selectedIndex: 0,
        checked: [],
        attachmentIds: [],
        attachmentNames: [],
    };
}
function normalizeTemplateFieldValue(value) {
    if (!value)
        return emptyTemplateFieldValue();
    return {
        text: value.text ?? '',
        selectedIndex: value.selectedIndex ?? 0,
        checked: Array.isArray(value.checked) ? value.checked : [],
        attachmentIds: Array.isArray(value.attachmentIds) ? value.attachmentIds : [],
        attachmentNames: Array.isArray(value.attachmentNames) ? value.attachmentNames : [],
    };
}
function findStickedUploadBox(fields) {
    let editorIndex = null;
    for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        if (field.type === 'editor' && field.uploadable) {
            editorIndex = i;
            continue;
        }
        if (field.type === 'upload_box' && editorIndex !== null) {
            if (field.required && field.uploadable) {
                return { editorIndex, uploadBoxIndex: i };
            }
            if (i - 1 === editorIndex) {
                return { editorIndex, uploadBoxIndex: i };
            }
        }
    }
    return null;
}
function isUploadBoxHidden(fieldIndex, field, stickedUpload) {
    return field.type === 'upload_box'
        && stickedUpload?.uploadBoxIndex === fieldIndex;
}
function createInitialTemplateFormValues(fields) {
    return fields.map((field) => {
        const defaultText = typeof field.value === 'string'
            ? field.value
            : '';
        if (field.type === 'dropdown' && field.options?.length) {
            const matchedIndex = field.options.findIndex((option) => option === defaultText);
            return {
                text: '',
                selectedIndex: matchedIndex >= 0 ? matchedIndex : 0,
                checked: [],
                attachmentIds: [],
                attachmentNames: [],
            };
        }
        if (field.type === 'checkbox_list' && field.options?.length) {
            return {
                text: '',
                selectedIndex: 0,
                checked: field.options.map(() => false),
                attachmentIds: [],
                attachmentNames: [],
            };
        }
        return {
            text: defaultText,
            selectedIndex: 0,
            checked: [],
            attachmentIds: [],
            attachmentNames: [],
        };
    });
}
function validateTemplateForm(fields, values, stickedUpload) {
    for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        const value = values[i];
        if (!field.required || field.type === 'title') {
            continue;
        }
        if (isUploadBoxHidden(i, field, stickedUpload)) {
            const editorValue = values[stickedUpload.editorIndex];
            if (editorValue.attachmentIds.length === 0) {
                return field.label || 'Загрузите вложение';
            }
            continue;
        }
        switch (field.type) {
            case 'text':
            case 'editor':
                if (!value.text.trim()) {
                    return field.label || 'Заполните обязательное поле';
                }
                break;
            case 'dropdown':
                if (!field.options?.[value.selectedIndex]) {
                    return field.label || 'Выберите значение';
                }
                break;
            case 'checkbox_list':
                if (!value.checked.some(Boolean)) {
                    return field.label || 'Выберите хотя бы один пункт';
                }
                break;
            case 'upload_box':
                if (value.attachmentIds.length === 0) {
                    return field.label || 'Загрузите вложение';
                }
                break;
        }
    }
    return null;
}
function buildTemplateSubmitPayload(fields, values, stickedUpload) {
    let editorAttachments = [];
    const payload = [];
    for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        const value = values[i];
        switch (field.type) {
            case 'title':
                payload.push(0);
                break;
            case 'text':
            case 'editor':
                payload.push(value.text);
                if (field.type === 'editor' && stickedUpload?.editorIndex === i) {
                    editorAttachments = value.attachmentIds;
                }
                break;
            case 'dropdown':
                payload.push(value.selectedIndex + 1);
                break;
            case 'checkbox_list':
                payload.push(value.checked
                    .map((checked, index) => (checked ? index + 1 : null))
                    .filter((item) => item != null));
                break;
            case 'upload_box':
                if (stickedUpload?.uploadBoxIndex === i) {
                    payload.push(editorAttachments);
                }
                else {
                    payload.push(value.attachmentIds);
                }
                break;
            default:
                payload.push(value.text);
                break;
        }
    }
    return payload;
}
/** Заголовок темы из поля `title` в форме `fw`. */
function extractTemplateFormTitle(fields, values) {
    const index = fields.findIndex((field) => field.type === 'title');
    if (index < 0)
        return '';
    return values[index]?.text?.trim() ?? '';
}
